export const onSelectTimeDifference = 60;
export const scameTimeMeasure = 60;
export const cvat_host='http://172.168.10.175:8080/'

export const frameViewColor = "#00cec9";
export const grabberColors = [
  "#e74c3c", // Red
  "#3498db", // Blue
  "#f1c40f", // Yellow
  "#e67e22", // Orange
  "#9b59b6", // Purple
  "#e91e63", // Pink
  "#34495e", // Brownish Gray
  "#2c3e50", // Dark Blue
  "#ecf0f1", // Light Gray
  "#95a5a6", // Gray
  "#1abc9c", // Cyan
  "#9b27af", // Magenta
  "#16a085", // Teal
  "#2980b9", // Navy
  "#7f8c8d", // Olive Gray
  "#8e44ad", // Dark Purple
  "#f39c12", // Coral
  "#4b6584", // Indigo
  "#00cec9", // Turquoise
  "#ffcccc",
  "#18dcff",
  "#ff4d4d",
  "#fffa65",
  "#67e6dc",
  "#ff3838",
  "#575fcf",
  "#4bcffa",
  "#34e7e4",
  "#ffc048",
  "#ffdd59",
  "#d2dae2",
  "#485460",
  "#f53b57",
  "#3c40c6",
  "#0fbcf9",
  "#00d8d6",
  "#ffa801",
  "#ffd32a",
  "#ff3f34",
  "#808e9b",
  "#1e272e",
  "#f3a683",
  "#f7d794",
  "#778beb",
  "#e77f67",
  "#cf6a87",
  "#786fa6",
  "#f8a5c2",
  "#63cdda",
  "#ea8685",
  "#596275",
  "#f19066",
  "#f5cd79",
  "#546de5",
  "#e15f41",
  "#c44569",
  "#574b90",
  "#f78fb3",
  "#3dc1d3",
  "#e66767",
  "#303952",
  "FF00FF",
  "7B68EE",
  "1E90FF",
  "C71585",
  "AA00FF",
  "00838F",
  "EF9A9A",
  "F48FB1",
  "CE93D8",
  "CE93D8",
  "9FA8DA",
  "90CAF9",
  "81D4FA",
  "80DEEA",
  "80CBC4",
  "FFE082",
  "FFCC80",
  "BCAAA4",
  "EEEEEE",
  "B0BEC5",
  "FF8A80",
  "FF80AB",
  "EA80FC",
  "B388FF",
  "8C9EFF",
  "82B1FF",
  "80D8FF",
  "84FFFF",
  "FF1744",
  "F50057",
  "D500F9",
  "651FFF",
  "3D5AFE",
  "2979FF",
  "2979FF",
  "00E5FF",
  "1DE9B6",
  "FFC400",
  "FF9100",
  "FF3D00"
];

export const annotationMockData = {
  video: "url",
  id: "asdf",
  labels: [
    {
      name: "label1",
      sublabel: [
        {
          subname: "sublabel1",
          timings: [
            {
              start: 5,
              end: 20,
            },
            {
              start: 25,
              end: 50,
            },
          ],
        },
        {
          subname: "sublabel2",
          timings: [
            {
              start: 50,
              end: 120,
            },
            {
              start: 120,
              end: 180,
            },
          ],
        },
        {
          subname: "sublabel2",
          timings: [
            {
              start: 180,
              end: 200,
            },
            {
              start: 200,
              end: 250,
            },
          ],
        },
      ],
    },
    {
      name: "label2",
      sublabel: [
        {
          subname: "sublabel1",
          timings: [
            {
              start: 14,
              end: 25,
            },
            {
              start: 18,
              end: 25,
            },
          ],
        },
        {
          subname: "sublabel2",
          timings: [
            {
              start: 4,
              end: 15,
            },
            {
              start: 8,
              end: 66,
            },
          ],
        },
        {
          subname: "sublabel2",
          timings: [
            {
              start: 34,
              end: 65,
            },
            {
              start: 39,
              end: 47,
            },
          ],
        },
      ],
    },
  ],
};
